import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private toastController: ToastController) {}

  async presentToast(
    position: 'top' | 'middle' | 'bottom',
    message: string = 'OK',
    duration: number = 1500,
    icon?: string,
    cssClass?: string,
  ): Promise<HTMLIonToastElement> {
    const toast = await this.toastController.create({
      message,
      duration,
      position,
      icon,
      cssClass,
      buttons: [
        {
          icon: 'close',
          role: 'cancel',
        },
      ],
    });

    toast.present();

    return toast;
  }
}
